import { format } from 'date-fns';
/** https://github.com/date-fns/date-fns/issues/2188 */
import * as ru from 'date-fns/locale/ru';
export function formatDateLabel(date) {
  if (!date) {
    return 'Другая дата';
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return format(new Date(date.year, date.month - 1, date.day), 'd MMMM', {
    locale: ru
  });
}
export function formatDateTime(date) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return "".concat(format(date, "d MMMM 'в' HH:mm", {
    locale: ru
  }));
}
export function formatPhoneNumber(phoneNumber) {
  if (phoneNumber.length <= 6) {
    return phoneNumber.replace(/(\d{3})(\d{1,3})/, '$1 $2');
  } else if (phoneNumber.length <= 8) {
    return phoneNumber.replace(/(\d{3})(\d{3})(\d{0,2})/, '$1 $2-$3');
  }
  return phoneNumber.replace(/(\d{3})(\d{3})(\d{2})(\d{0,2})/, '$1 $2-$3-$4');
}